<template>
  <div
    class="-remove -action"
    @click.stop="$emit('remove')"
    v-tooltip="tooltipOptions"
  >
    <span class="wticon wticon-trash-line"></span>
  </div>
</template>

<script>
export default {
  name: 'AssetRemove',
  computed: {
    tooltipOptions() {
      return {
        title: 'Remove',
        placement: 'top auto',
        wrapperClass: 'dark',
        delay: { show: 250, hide: 0 },
        container: '.tooltip-container',
      };
    },
  },
};
</script>
